<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    },
    handleTagsView() {
      this.$nextTick(() => {
        if (this.$route.meta.noCache) {
          this.$store.dispatch('tagsView/delAllViews')
        } else {
          const view = {
            fullPath: this.$route.fullPath,
            meta: this.$route.meta,
            name: this.$route.name,
            path: this.$route.path,
            query: this.$route.query,
            title: this.$route.meta.title || 'no-name'
          }
          this.$store.dispatch('tagsView/addVisitedView', view)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  // height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header+.app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 + 48 */
    // min-height: calc(100vh - 132px);
    height: 100% ;
  }

  .fixed-header+.app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
